import React from 'react';
import styled from 'styled-components';

import sharedStyles from '@repo/ui-components/styles';

import SupportArticleTableOfContents from './support-article-section-types/SupportArticleTableOfContents';
import SupportArticleSectionTypes from './support-article-section-types';
import breakpoints from '../breakpoints';
import SupportArticleFeedbackForm from './SupportArticleFeedbackForm';

const SupportArticleContainer = styled.div`
  padding: ${sharedStyles.spacing['spacing-lg']};
  background-color: white;
  padding-top: ${sharedStyles.spacing['spacing-2xl']};

  @media (min-width: ${breakpoints.lg}) {
    padding: ${sharedStyles.spacing['spacing-lg']};
  }
`;

const SupportArticleTitle = styled.h1`
  text-align: center;
  padding-bottom: 1em;
`;

const SupportArticleSection = styled.div`
  padding-bottom: ${sharedStyles.spacing['spacing-lg']};
`;

function SupportArticle({ article }) {
  return (
    <SupportArticleContainer>
      <SupportArticleTitle>{article?.title}</SupportArticleTitle>
      {article?.body?.includeTableOfContents && (
        <SupportArticleTableOfContents sections={article?.body?.sections} />
      )}
      {article?.body?.sections?.map((section, index) => {
        if (SupportArticleSectionTypes.hasOwnProperty(section._type)) {
          return (
            <SupportArticleSection key={section._key}>
              {React.createElement(SupportArticleSectionTypes[section._type], {
                section: section,
              })}
            </SupportArticleSection>
          );
        }
      })}
      <SupportArticleFeedbackForm
        articleId={article.id}
        articleSlug={article.slug.current}
      />
    </SupportArticleContainer>
  );
}

export default SupportArticle;
